module.exports = __webpack_public_path__ + "img/WasSuchtSie.b1391942.svg";